import { Page } from "components/Page";

import "react-tabulator/css/bootstrap/tabulator_bootstrap.min.css";
import "react-tabulator/lib/styles.css";

import { useEffect, useState } from "react";
import { Outlet, useRouteLoaderData } from "react-router-dom";
import { DiscrepancyRecord } from "services/DiscrepancyRecord";

const DiscrepancyRecordsView = () => {
  const viewData: DiscrepancyRecord | any = useRouteLoaderData(
    "view_discrepancy_id"
  );
  const editData: DiscrepancyRecord | any = useRouteLoaderData(
    "edit_discrepancy_id"
  );
  const deleteData: DiscrepancyRecord | any = useRouteLoaderData(
    "delete_discrepancy_id"
  );
  const [id, setId] = useState<string>("");

  useEffect(() => {
    if (viewData !== undefined) {
      setId(viewData.id);
    } else if (editData !== undefined) {
      setId(editData.id);
    } else if (deleteData !== undefined) {
      setId(deleteData.id);
    } else {
      setId("");
    }
  }, [viewData, editData, deleteData]);

  return (
    <Page
      title={id}
      parentRoute="/Discrepancies"
      label="Discrepancies"
      breadCrumb={{ id: "cpn", title: id, active: id ? true : undefined }}
    >
      <Outlet />
    </Page>
  );
};

export default DiscrepancyRecordsView;
